import React, { useEffect, useState } from 'react'
import RichTextEditor from 'react-rte'
import styled from 'styled-components'
import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import LabelInput from 'components/Form/LabelInput'
import { FONT } from 'theme/font'

const toolbarConfig = {
  display: [
    'INLINE_STYLE_BUTTONS',
    'BLOCK_TYPE_BUTTONS',
    'BLOCK_TYPE_DROPDOWN',
  ],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD', className: 'header-button' },
    { label: 'Italic', style: 'ITALIC', className: 'header-button' },
    { label: 'Underline', style: 'UNDERLINE', className: 'header-button' },
  ],
  BLOCK_TYPE_DROPDOWN: [
    { label: 'Normal text', style: 'unstyled' },
    { label: 'Heading 1', style: 'header-one' },
    { label: 'Heading 2', style: 'header-two' },
    { label: 'Heading 3', style: 'header-three' },
  ],
  BLOCK_TYPE_BUTTONS: [
    {
      label: 'UL',
      style: 'unordered-list-item',
      className: 'header-button',
    },
    { label: 'OL', style: 'ordered-list-item', className: 'header-button' },
  ],
}

const StyledEditor = styled(RichTextEditor)`
  margin-top: 10px;
  font-family: ${FONT.FONT_FAMILY};
  height: auto;
  > div {
    background: #f9fafa;
  }
  .header-button {
    border: none;
  }
  .public-DraftEditor-content {
    min-height: ${props => (props.size === 'small' ? '50px' : '250px')};
    padding: 0px 9px 10px 9px;
  }
  .IconButton__icon___3YgOS {
    background-size: 22px;
    border-radius: 15px;
  }
  .DraftEditor-editorContainer {
    padding: 10px 0;
  }
  .EditorToolbar__root___3_Aqz {
    margin: 0;
    padding: 10px 5px;
  }
  .DraftEditor-root {
    background: #ffffff;
  }
`

const RichEditor = ({
  onChange,
  value = '',
  labelName = 'Job description *',
  placeholder = 'Enter job description here...',
  editText = false,
  isImportant = false,
  size = 'large',
  error,
  disabled,
  name,
  maxLength = 2000, // default max characters
  onBlur,
}) => {
  const [state, setState] = useState({
    description: value
      ? RichTextEditor.createValueFromString(value, 'html')
      : RichTextEditor.createEmptyValue(),
    error: '',
  })

  const [charCount, setCharCount] = useState(0)

// Allow unlimited typing
const handleBeforeInput = () => {
  return 'not-handled';
};

// Allow unlimited pasting
const handlePastedText = () => {
  return 'not-handled';
}

  const handleOnchange = (val, key) => {
    const html = val.toString('html')
    const plainText = val.getEditorState().getCurrentContent().getPlainText('')
    setCharCount(plainText?.length)
    setState(prev => ({
      ...prev,
      [key]: val,
      error: '',
    }))
    if (onChange) {
      onChange(html)
    }
  }
  const stripHtmlTags = html => {
    const div = document.createElement('div')
    div.innerHTML = html
    return div.textContent || div.innerText || ''
  }
  useEffect(() => {
    const plainText = stripHtmlTags(state?.description?.toString('html'))
    const characterCount = plainText.length
    setCharCount(characterCount)
    
    // Only update if the value is actually different from current state
    const currentHtml = state?.description?.toString('html') || ''
    const newValue = value || ''
    
    // Compare stripped text to avoid HTML formatting differences
    const currentText = stripHtmlTags(currentHtml)
    const newText = stripHtmlTags(newValue)
    
    if (currentText !== newText) {
      setState(prev => ({
        ...prev,
        description: value
          ? RichTextEditor.createValueFromString(value, 'html')
          : RichTextEditor.createEmptyValue(),
        error: '',
      }))
    }
  }, [editText, value])

  return (
    <div name={name}>
      <Flex centerVertically>
        <LabelInput isImportant={isImportant}>{labelName}</LabelInput>
      </Flex>
      <StyledEditor
        size={size}
        value={state.description}
        toolbarConfig={toolbarConfig}
        onChange={val => handleOnchange(val, 'description')}
        placeholder={placeholder}
        readOnly={disabled}
        onBlur={onBlur}
        handleBeforeInput={handleBeforeInput}
        handlePastedText={handlePastedText}
      />
      {labelName == 'About Company' && (
        <div
          style={{
            textAlign: 'right',
            fontSize: 13,
            color: '#888',
            marginTop: 4,
          }}
        >
          {charCount}/{maxLength}
        </div>
      )}
      {(state.error || error) && (
        <span style={{ color: 'red', fontSize: '12px' }}>
          {state.error || error}
        </span>
      )}
    </div>
  )
}

export default RichEditor
